import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PrivateAxios, publicAxios } from '../api';

const initialState = {
  getUser: [],
  status: 'idle',
  error: null,
};

export const fetchUser = createAsyncThunk('getUser/fetchUser', async () => {
  const response = await PrivateAxios.get('/api/user/getUser');
  return response.data.data.user;
});

const getUserSlice = createSlice({
  name: 'getUser',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.getUser = action.payload;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default getUserSlice.reducer;